// document.addEventListener("DOMContentLoaded", function () {
//   const stoneFilterDivs = document.querySelectorAll('[data-filter="Stone Type"]');

//     const filters = [
//       {
//         label: "GIA Diamond",
//         value: "GIA Diamond",
//         url: "https://beverlydiamonds.com/collections/diamond-engagement-rings"
//       },
//       {
//         label: "Lab Diamond",
//         value: "Lab Diamond",
//         url: "https://beverlydiamonds.com/collections/lab-diamond-engagement-rings-1"
//       },
//       {
//         label: "Moissanite",
//         value: "Moissanite",
//         url: "https://beverlydiamonds.com/collections/moissanite-engagement-rings"
//       }
//     ];

//     stoneFilterDivs.forEach((stoneFilterDiv, groupIndex) => {
//       const ul = document.createElement("ul");
//       ul.setAttribute("role", "list");

//       filters.forEach((filter, index) => {
//         const li = document.createElement("li");
//         li.className = "list-none mb-3 eurus";

//         const inputId = `Filter-above-Stone-Type-${groupIndex}-${index + 1}`;

//         li.innerHTML = `
//           <label for="${inputId}" class="flex items-center cursor-pointer">
//             <input
//               type="checkbox"
//               id="${inputId}"
//               class="checkbox checkbox-checked h-6 w-6 min-w-[24px] border checked:border-[rgba(var(--colors-text-link))] checked:bg-[rgba(var(--colors-text-link))] relative cursor-pointer mr-2 rounded"
//               name="filter.p.m.spec.stone_type"
//               value="${filter.value}"
//             >
//             <span class="p-break-words">${filter.label}</span>
//           </label>
//         `;

//         setTimeout(() => {
//           const input = li.querySelector("input");
//           if (input) {
//             input.addEventListener("change", () => {
//               window.location.href = filter.url;
//             });
//           }
//         }, 0);

//         ul.appendChild(li);
//       });

//       // Replace content
//       stoneFilterDiv.innerHTML = "";
//       stoneFilterDiv.appendChild(ul);
//     });
// });

function initializeStoneTypeFilter() {
  const facetForm = document.querySelector(".facets #FacetFiltersForm, .facets form.form-aside");

  // debugger;
  // If no [data-filter="Stone Type"] exists, inject the filter HTML
  if (!facetForm.querySelector('[data-filter="Stone Type"]')) {
    const filterWrapper = document.createElement("div");
    filterWrapper.setAttribute("data-filter", "Stone Type");
    filterWrapper.className = "js-filter relative";
    filterWrapper.setAttribute("data-index", "above-3");
    filterWrapper.setAttribute("x-data", "{open: false}");
    // filterWrapper.setAttribute("@click", "getPopupPosition($el)");
    // filterWrapper.setAttribute("x-intersect.once", "setPositionOptionFilter($el)");

    filterWrapper.innerHTML = `
      <button @click.prevent="open=!open" :class="open && 'md:shadow-[rgba(0,0,0,0.16)_0px_0px_0px,rgb(var(--colors-heading))_0px_0px_0px_1px]'"
              class="facets__summary w-full relative cursor-pointer flex pt-3 pb-3 border-solid items-center border-b justify-between md:border md:py-3 md:px-4 rounded"
              aria-label="Stone Type (1 selected)">
        <span class="text-medium text-[rgba(var(--colors-heading))] md:mr-7">Stone Type<span> (1)</span></span>
        <span class="h-2.5 w-2.5 inline-block duration-300 rotate-0" :class="open ? 'rotate-180':'rotate-0'">
          <svg width="100%" height="100%" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.75 1.625L4.5 5.375L8.25 1.625" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </button>
      <div class="popup-above max-h-[calc(75vh-var(--height-header))] scrollbar-body overflow-auto border-b md:border-0 border-solid md:absolute md:top-[calc(100%+10px)] md:p-4 md:z-20 md:bg-[rgba(var(--background-color))] md:w-max max-w-xs md:shadow-[rgba(0,0,0,0.15)_0px_5px_15px_0px]" @click.away="open=false" x-show="open" style="display: none;">
        <div class="flex justify-between py-4 text-[0.70875rem] md:text-[0.7875rem] md:pt-1 md:pb-2 border-b">
          <div><span class="facets__selected">1 selected</span></div>
          <button class="facet-reset cursor-pointer ml-5" @click.prevent="removeFilter(window.location.href)">Reset</button>
        </div>
        <div data-filter="Stone Type" class="md:pb-5 pb-4 pr-2 pt-3 scrollbar-body overflow-y-auto">
          <ul role="list"></ul>
        </div>
      </div>
    `;
    facetForm.querySelector("div").appendChild(filterWrapper);
    // debugger;
  }

  // Now get the inner Stone Type div(s)
  const stoneFilterDivs = document.querySelectorAll('#FacetFiltersForm [data-filter="Stone Type"],  .facets form.form-aside [data-filter="Stone Type"]');

  const path = window.location.pathname;
  const pathParts = path.split('/');
  const collectionSlug = pathParts.includes("collections") ? pathParts[pathParts.indexOf("collections") + 1] : "";

  let base = "";
  if (collectionSlug.startsWith("lab-diamond-")) {
    base = collectionSlug.replace("lab-diamond-", "");
  } else if (collectionSlug.startsWith("moissanite-")) {
    base = collectionSlug.replace("moissanite-", "");
  } else if (collectionSlug.startsWith("diamond-")) {
    base = collectionSlug.replace("diamond-", "");
  }

  const filters = [
    {
      label: "Diamond",
      value: "GIA Diamond",
      url: "/collections/diamond-" + base
    },
    {
      label: "Lab Diamond",
      value: "Lab Diamond",
      url: "/collections/lab-diamond-" + base
    },
    {
      label: "Moissanite",
      value: "Moissanite",
      url: "/collections/moissanite-" + base
    }
  ];

  stoneFilterDivs.forEach((stoneFilterDiv, groupIndex) => {
    const ul = stoneFilterDiv.querySelector("ul[role='list']");
    if (!ul) return;

    ul.innerHTML = ""; // Clear old items

    filters.forEach((filter, index) => {
      const inputId = `Filter-above-Stone-Type-0-${index + 1}`;
      const isSelected = path.includes(filter.url) || path === filter.url + "-1";

      const li = document.createElement("li");
      li.className = "list-none mb-3 eurus";
      li.innerHTML = `
        <label for="${inputId}" class="flex items-center cursor-pointer">
          <input
            type="checkbox"
            id="${inputId}"
            class="checkbox checkbox-checked h-6 w-6 min-w-[24px] border checked:border-[rgba(var(--colors-text-link))] checked:bg-[rgba(var(--colors-text-link))] relative cursor-pointer mr-2 rounded"
            name="filter.p.m.spec.stone_type"
            value="${filter.value}"
            ${isSelected ? "checked" : ""}
          >
          <span class="p-break-words">${filter.label}</span>
        </label>
      `;

      const input = li.querySelector("input");
      input.addEventListener("change", () => {
        if (input.checked) {
          if (
            filter.url === "/collections/lab-diamond-engagement-rings" ||
            filter.url === "/collections/lab-diamond-bridal-sets"
          ) {
            window.location.href = filter.url + "-1";
          } else {
            if (filter.url.includes("-1") && !filter.url.includes("lab-diamond-")) {
              window.location.href = filter.url.replaceAll("-1", "");
            } else {
              window.location.href = filter.url;
            }
          }
        }
      });

      ul.appendChild(li);
    });
  });
}


// Initial run on page load
document.addEventListener("DOMContentLoaded", function () {
  initializeStoneTypeFilter();

  window.initStone = initializeStoneTypeFilter;
  // Debounced re-run when any [data-filter] input changes
  let debounceTimer;
  document
    .querySelectorAll('[data-filter="Stone Type"] input')
    .forEach((input) => {
      input.addEventListener("change", function () {
        const stoneFilterDiv = document.querySelector(
          '[data-filter="Stone Type"]'
        );

        if (this.checked) {
          // Disable the entire Stone Type filter (graying it out or preventing interaction)
          stoneFilterDiv.querySelectorAll("input").forEach((checkbox) => {
            checkbox.disabled = true; // Disable all checkboxes
            checkbox.closest("li").classList.add("disabled"); // Optionally, add a disabled class for styling
          });
        } else {
          // Enable the entire Stone Type filter when unchecked
          // If none of the checkboxes are checked, make the filter interactive
          if (
            ![...stoneFilterDiv.querySelectorAll("input")].some(
              (input) => input.checked
            )
          ) {
            stoneFilterDiv.querySelectorAll("input").forEach((checkbox) => {
              checkbox.disabled = false; // Enable all checkboxes
              checkbox.closest("li").classList.remove("disabled"); // Remove the disabled class for styling
            });
          }
        }
      });
    });

  // document.querySelectorAll('[data-filter] input').forEach(input => {
  //   input.addEventListener('change', () => {
  //     clearTimeout(debounceTimer);
  //     // debugger;
  //     debounceTimer = setTimeout(() => {
  //       initializeStoneTypeFilter();
  //     }, 3500); // adjust delay as needed
  //   });
  // });
});
